import Reflux from 'reflux'

export default Reflux.createActions(['domReady','test','popUpDomReady','lookupBeforeClose']);


// WEBPACK FOOTER //
// ./src/actions/DomActions.js